import type { Project } from "@akhshy/types";
import { ProjectCard } from "../molecules/ProjectCard.tsx";
import { Spinner } from "../atoms/Spinner.tsx";
import { LoadMore } from "../atoms/LoadMore.tsx";
import { usePaginated } from "../../lib/usePaginated.ts";
import { client } from "../../lib/api.ts";
import { FALLBACK_PROJECTS } from "../../lib/fallback.ts";

export function ProjectsTray() {
  const { items, loading, hasMore, total, loadMore } = usePaginated<Project>(
    (page) => client.projects.list({ page, pageSize: 6 }),
    [],
    FALLBACK_PROJECTS.slice(0, 6),
  );

  return (
    <div className="tray-box">
      <span className="tray-label">— from the tray —</span>
      <h3 className="tray-heading">Shipped, mostly working</h3>
      <p className="tray-sub">The ones I'm actively tending right now.</p>
      {loading && items.length === 0 ? (
        <Spinner label="lifting the lid on the tray" />
      ) : (
        <>
          <div className="projects">
            {items.map((p) => (
              <ProjectCard key={p.id} project={p} />
            ))}
          </div>
          <LoadMore
            hasMore={hasMore}
            loading={loading}
            total={total}
            count={items.length}
            onClick={loadMore}
          />
        </>
      )}
    </div>
  );
}
